import * as React from "react";
import Modal from "react-modal";

// Set the app element for accessibility (avoids warning)
if (typeof document !== "undefined") {
  Modal.setAppElement(document.body);
}

export interface ModalProps {
  isOpen: boolean;
  shouldCloseOnOverlayClick?: boolean;
  onRequestClose?(): void;
  onAfterOpen?(): void;
  overlayClass?: string;
  className?: string;
  role?: string;
  labelledby?: string;
  describedby?: string;
  isModal?: boolean;
  closeTimeOutMS?: number;
}

export interface ModalState {}

/**
 * Generic Dialogue component that renders its children.
 */
export class Dialog extends React.Component<ModalProps, ModalState> {
  static defaultProps = {
    onRequestClose: () => {},
    onAfterOpen: () => {},
    isOpen: false,
    shouldCloseOnOverlayClick: true,
    role: "dialog",
    isModal: true,
  };

  public render() {
    return (
      <div>
        <Modal
          closeTimeoutMS={this.props.closeTimeOutMS}
          className={this.props.className}
          role={this.props.role}
          aria={{
            labelledby: this.props.labelledby,
            describedby: this.props.describedby,
            modal: this.props.isModal,
          }}
          overlayClassName={this.props.overlayClass}
          ariaHideApp={true}
          isOpen={this.props.isOpen}
          onRequestClose={this.props.onRequestClose}
          shouldCloseOnOverlayClick={this.props.shouldCloseOnOverlayClick}
          onAfterOpen={this.props.onAfterOpen}
        >
          {this.props.children}
        </Modal>
      </div>
    );
  }
}
